import { Separator } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import Link from 'components/Link'
import { articlePath } from 'libs/paths'
import { ARTICLES_TYPE } from 'types'
import { formattedDate } from '../../../components/utils'

const OtherArticles = ({ articles }) => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='col-12 col-md-4 col-lg-3'>
      <div className='mc-bg-gray-700 mc-p-8'>
        <h2 className='mc-text--airy'>{t('article.relatedArticles.title')}</h2>
        <Separator className='mc-text-x-small mc-my-4' />
        {articles?.map((article) => (
          <Link
            className='d-block mc-mb-6'
            key={article.slug}
            href={articlePath(article.slug)}
            passHref
          >
            <p className='mc-text-h7'>{article.title}</p>
            <p className='mc-opacity--muted mc-text-x-small mc-mt-1'>
              {formattedDate(article.updatedAt)}
            </p>
          </Link>
        ))}
      </div>
    </div>
  )
}

OtherArticles.propTypes = {
  articles: ARTICLES_TYPE,
}

export default OtherArticles
